import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const AccStatusModal = (props) => {
    
    return (
        <Modal show={props.show} onHide={props.hide}>
            <Modal.Header closeButton>
                <Modal.Title>Estas seguro?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Estas seguro que deseas {props.activate ? 'activar' : 'desactivar'} a este usuario?
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.hide}>Close</Button>
                <Button variant={props.activate ? "success" : "danger"} onClick={props.onSuccess}>{props.activate ? 'Activar' : 'Desactivar'} Cuenta</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AccStatusModal;